import ActionTypes from './action-types'
import MutationTypes from './mutation-types'
import GetterTypes from './getter-types'

export default {
  ...ActionTypes,
  ...MutationTypes,
  ...GetterTypes
}
